import { Box, Spacer } from '@jfs/ui-new'
import { SubTitle } from '../../comps/SubTitle'
import { Title } from '../../comps/Title'
import { method } from '../../network/executeTransaction'
import { getDDMMMYYDateFromIST, getFormattedAmount } from '../../util/utill'
import { StatusText } from './StatusText'

interface TransactionListItemProps {
  onPress: (data: any) => void
  data: any
}

export const TransactionListItem = ({ data, onPress }: TransactionListItemProps) => {
  const subTitle = (() => {
    const type = parseInt(data?.transaction?.method?.type)
    if (type === method.CASH_WITHDRAWAL || type === method.FUND_TRANSFER) {
      //payer
      return (
        (data?.transaction?.rrn ? `RRN No: ${data?.transaction?.rrn}` : '') +
        (data?.payer?.mobileNumber ? ` | Mobile Number: ${data?.payer?.mobileNumber}` : '') +
        (data?.payer?.bankName ? ` | Bank Name: ${data?.payer?.bankName}` : '')
      )
    } else {
      //payee
      return (
        (data?.transaction?.rrn ? `RRN No: ${data?.transaction?.rrn}` : '') +
        (data?.payee?.mobileNumber ? ` | Mobile Number: ${data?.payee?.mobileNumber}` : '') +
        (data?.payee?.bankName ? ` | Bank Name: ${data?.payee?.bankName}` : '')
      )
    }
  })()
  return (
    <Box
      flexDirection={'row'}
      borderBottomWidth={1}
      borderColor="GRAY_BORDER"
      height={'100%'}
      underlayColor="GRAY_LIGHT"
      onPress={() => {
        onPress(data)
      }}
      paddingHorizontal={16}
      justifyContent="space-between"
      alignItems={'center'}
      alignContent="center">
      <Box flexDirection={'column'} alignItems={'flex-start'} flex={1}>
        <Title title={getDDMMMYYDateFromIST(data?.transaction?.created)} />
        <Spacer direction="vertical" size={6} />
        <SubTitle subTitle={subTitle} textAlign="left" />
      </Box>

      <Box flexDirection={'column'} alignItems={'flex-end'}>
        <Title title={getFormattedAmount(+(data?.amount?.netAmount ?? '0'))} />
        <Spacer direction="vertical" size={6} />
        <StatusText text={data?.transaction?.status} />
      </Box>
    </Box>
  )
}
